import Echo from "laravel-echo"
import store from "./storage"
import io from 'socket.io-client'
import app from "./main";
import bus from "./js/BusEmisor";

export default () => {

	if (!app) {
		return false;
	}

	app.io = io;

	let events = [
		{
			name: "CourseEvent",
			eventBus: "update_course_info"
		},
		{
			name: "PanelAdmin\\KllaarActivationAccount",
			eventBus: "update_user_active"
		},
	];

	app.Echo = new Echo({
		client: app.io,
		broadcaster: 'socket.io',
		host: "https://api.kllaar.com/:6002",
	});

	let channelEcho = app.Echo.channel('kllaar');

	events.forEach((event) => {
		channelEcho.listen(event.name, (data) => {
			if (event.dispatcher) {
				store.dispatch(event.dispatcher, false).then(
					async () => {
						app.$forceUpdate();
					}
				)
			}
			if (event.eventBus && !event.busDefined) {
				bus.$emit(event.eventBus, data);
				event.busDefined = true;
			}
		});
	})
}



// WEBPACK FOOTER //
// ./src/events.js